/**
 * LE PARCOURS PROFESSIONNEL PORTE SON PARAMETRE JUSQU'AU BOUT.
 *
 * Adrien, 22/08/2026 : « il faut un funnel different pour le B2B. Toutes les pages accessibles
 * depuis B2B doivent porter l'url parameter ?pro=1. »
 *
 * ⛔ POURQUOI UN PARAMETRE ET PAS UNE PAGE A PART. Le catalogue est le MEME : memes affiches,
 * memes fiches. Ce qui change est l'affichage (hors taxes, tarif degressif) et ce qu'on ne montre
 * pas (les promos grand public). Dupliquer 1 800 fiches pour ca serait 1 800 occasions de
 * divergence. Le parametre marque le parcours, pas le produit.
 *
 * ⛔ ET IL DOIT SE PROPAGER TOUT SEUL. Un lien pose sans le parametre fait retomber le visiteur
 * dans le parcours grand public sans que rien ne le signale : ni erreur, ni page differente, juste
 * des prix TTC et une promo saisonniere au milieu d'un devis. Trois portes, parce qu'une seule ne
 * suffit pas :
 *   1. tous les liens presents au chargement ;
 *   2. ceux qui arrivent APRES (tiroir de panier, suggestions de recherche, filtres, defilement
 *      infini) : un observateur les reprend ;
 *   3. le clic lui-meme, en capture, pour les liens dont l'adresse est ecrite au dernier moment.
 *
 * ⚠️ LE DRAPEAU VIT DANS `sessionStorage`, PAS DANS UN COOKIE. Il ne doit pas suivre le visiteur
 * d'un jour a l'autre ni d'un onglet neuf : un particulier qui tombe une fois sur une page pro ne
 * doit pas rester en mode professionnel pour toujours. `?pro=0` en sort explicitement.
 *
 * ⚠️ L'ATTRIBUT EST POSE SUR <html>, PAS SUR <body>, ET AVANT LA PEINTURE : sur <body> il
 * arriverait apres le premier rendu et le bandeau promo clignoterait.
 */
(function () {
  'use strict';

  var CLE = 'affichely_pro';
  var PARAM = 'pro';

  function actif() {
    var q = new URLSearchParams(window.location.search);
    if (q.get(PARAM) === '0') {
      try { sessionStorage.removeItem(CLE); } catch (e) { /* mode prive */ }
      return false;
    }
    if (q.get(PARAM) === '1') return true;
    if (document.documentElement.getAttribute('data-pro') === '1') return true;
    try { return sessionStorage.getItem(CLE) === '1'; } catch (e) { return false; }
  }

  if (!actif()) return;
  document.documentElement.setAttribute('data-pro', '1');
  try { sessionStorage.setItem(CLE, '1'); } catch (e) { /* mode prive */ }

  /* ⛔ CE QUI NE PREND PAS LE PARAMETRE. Le paiement appartient a Shopify et n'a que faire d'un
     marqueur de parcours ; les points d'entree du panier sont des API, pas des pages ; le compte
     client est hors du catalogue. Y coller un parametre inconnu ne casse rien, mais salit des
     adresses qu'on retrouve ensuite dans les journaux et dans les statistiques. */
  var EXCLUS = /^\/(checkout|account|apps|tools|services|wpm|cdn)(\/|$)|^\/cart\/(add|change|update|clear)|\.(js|json|xml|txt|css|png|jpe?g|webp|svg|pdf)$/i;

  function aReecrire(a) {
    if (!a || !a.getAttribute) return false;
    var brut = a.getAttribute('href');
    if (!brut || brut.charAt(0) === '#') return false;
    if (/^(mailto:|tel:|javascript:|data:)/i.test(brut)) return false;
    if (a.hasAttribute('download')) return false;
    if (a.getAttribute('target') === '_blank') return false;
    var u;
    try { u = new URL(a.href, window.location.href); } catch (e) { return false; }
    if (u.origin !== window.location.origin) return false;
    if (EXCLUS.test(u.pathname)) return false;
    if (u.searchParams.has(PARAM)) return false;
    return u;
  }

  function marquer(a) {
    var u = aReecrire(a);
    if (!u) return;
    u.searchParams.set(PARAM, '1');
    a.setAttribute('href', u.pathname + u.search + u.hash);
  }

  function balayer(racine) {
    var noeuds = (racine || document).querySelectorAll ? (racine || document).querySelectorAll('a[href]') : [];
    for (var i = 0; i < noeuds.length; i += 1) marquer(noeuds[i]);
  }

  /* ⚠️ LES FORMULAIRES EN GET PERDENT TOUT CE QUI N'EST PAS UN CHAMP. La recherche du site est un
     <form method="get" action="/search"> : sans champ cache, valider une recherche depuis une page
     pro renvoie une page de resultats grand public. */
  function marquerFormulaires(racine) {
    var fs = (racine || document).querySelectorAll ? (racine || document).querySelectorAll('form') : [];
    for (var i = 0; i < fs.length; i += 1) {
      var f = fs[i];
      var methode = (f.getAttribute('method') || 'get').toLowerCase();
      if (methode !== 'get') continue;
      var action = f.getAttribute('action') || window.location.pathname;
      if (EXCLUS.test(action)) continue;
      if (f.querySelector('input[name="' + PARAM + '"]')) continue;
      var champ = document.createElement('input');
      champ.type = 'hidden';
      champ.name = PARAM;
      champ.value = '1';
      f.appendChild(champ);
    }
  }

  /* ⛔ « UNE IDEE CADEAU » NE SE DIT PAS A UN HOTELIER (Adrien, 22/08/2026). Le champ de recherche
     porte les DEUX libelles : celui du grand public dans `placeholder`, celui du parcours pro dans
     `data-ph-pro`, tous deux TRADUITS PAR LE SERVEUR. Liquid ne voit pas `?pro=1` ; ecrire ce
     texte ici en clair aurait rendu du francais sur treize marches.
     ⚠️ ET CETTE FONCTION NE TOURNE QUE DANS LE PARCOURS PRO : le fichier entier sort par
     `if (!actif()) return;` bien avant. */
  function placeholderPro(racine) {
    var champs = racine.querySelectorAll('input[data-ph-pro]');
    for (var i = 0; i < champs.length; i += 1) {
      var v = champs[i].getAttribute('data-ph-pro');
      if (v) champs[i].setAttribute('placeholder', v);
    }
  }

  function tout() {
    balayer(document);
    marquerFormulaires(document);
    placeholderPro(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tout);
  } else {
    tout();
  }

  /* Deuxieme porte : ce qui arrive apres. Regroupe sur une frame, sinon un tiroir de panier qui
     se redessine declencherait un balayage par noeud ajoute. */
  var enAttente = false;
  function programmer() {
    if (enAttente) return;
    enAttente = true;
    requestAnimationFrame(function () { enAttente = false; tout(); });
  }
  if (window.MutationObserver) {
    var obs = new MutationObserver(function (lots) {
      for (var i = 0; i < lots.length; i += 1) {
        if (lots[i].addedNodes && lots[i].addedNodes.length) { programmer(); return; }
      }
    });
    var demarrer = function () {
      if (document.body) obs.observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) demarrer(); else document.addEventListener('DOMContentLoaded', demarrer);
  }

  /* Troisieme porte : le clic, en CAPTURE, avant tout gestionnaire de la page. Un lien dont
     l'adresse est ecrite au moment du clic n'a jamais ete vu par les deux premieres. */
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
    if (a) marquer(a);
  }, true);
}());
